import { Modal } from 'components/Modal'
import { getAgendaTableModalData } from 'constants/WorkingModePathwaysAgendaModals'

import { ModalHeader } from './ModalHeader'

interface AgendaTableModalProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

export const AgendaTableModal = ({ isOpen, onClose, id }: AgendaTableModalProps) => {
  const data = getAgendaTableModalData(id)
  if (!data) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="agenda-table-modal">
      <ModalHeader title={data.title} onClose={onClose} />

      <div className="agenda-table-scroll">
        <table className="agenda-table">
          <thead>
            <tr>
              <th>Time</th>
              {data.hasPhaseColumn && <th>Phase</th>}
              <th>Activities</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map(row => (
              <tr key={row.time} style={{ backgroundColor: row.timeColor }}>
                <td className="agenda-table-time" style={{ color: row.textColor }}>
                  {row.time}
                </td>
                {data.hasPhaseColumn && <td className="agenda-table-phase">{row.phase}</td>}
                <td className="agenda-table-activity">
                  {row.activityBold && <span className="font-bold">{row.activityBold} </span>}
                  {row.activity}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}
